var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.042,325.8l22.744-123.474A85.3,85.3,0,1,0,298.667,128H117l-1.543-6.945A31.815,31.815,0,0,0,84.219,96H53.333a10.667,10.667,0,1,0,0,21.333H84.219a10.609,10.609,0,0,1,10.417,8.354l57.844,260.3a42.752,42.752,0,1,0,49.747,19.346H336.44A42.63,42.63,0,1,0,373.333,384H173.891l-7.111-32H371.573A32,32,0,0,0,403.042,325.8ZM384,64a64,64,0,1,1-64,64A64.072,64.072,0,0,1,384,64ZM186.667,426.667a21.333,21.333,0,1,1-21.333-21.333A21.354,21.354,0,0,1,186.667,426.667Zm208,0a21.333,21.333,0,1,1-21.333-21.333A21.354,21.354,0,0,1,394.667,426.667ZM121.742,149.333H301.475a84.984,84.984,0,0,0,100.971,61.936L382.063,321.932a10.664,10.664,0,0,1-10.49,8.734H162.039Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352,138.667h21.333V160a10.667,10.667,0,0,0,21.333,0V138.667H416a10.667,10.667,0,1,0,0-21.333H394.667V96a10.667,10.667,0,0,0-21.333,0v21.333H352a10.667,10.667,0,0,0,0,21.333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCart);
export default __webpack_public_path__ + "static/media/addCart.31af5ff277d49bcecdd13f2ba88c305d.svg";
export { ForwardRef as ReactComponent };